import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2, ShieldCheck } from "lucide-react";

export default function AcceptInvite() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [zips, setZips] = useState("");
  const [phone, setPhone] = useState("");
  const [busy, setBusy] = useState(false);
  const { setUser } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return toast.error("Password must be at least 8 characters");
    if (pw !== pw2) return toast.error("Passwords don't match");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/accept-invite", { token, password: pw, territory_zips: zips, alert_phone: phone });
      setUser(data.user);
      toast.success("Welcome to the team!");
      nav(["admin", "staff"].includes(data.user?.role) ? "/admin" : "/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not accept invite");
      setBusy(false);
    }
  };

  if (!token) return <div className="max-w-md mx-auto py-24 px-6 text-center text-sam-slate" data-testid="invite-invalid">This invite link is invalid. Please ask your admin to re-send it.</div>;

  return (
    <div className="max-w-md mx-auto py-20 px-6" data-testid="accept-invite-page">
      <div className="rounded-2xl border border-border bg-card p-7 shadow-sm">
        <div className="inline-flex items-center gap-2 text-sam-crimson font-display font-bold text-xl mb-1"><ShieldCheck className="h-5 w-5" />Join the team</div>
        <p className="text-sm text-sam-slate mb-5">Set a password to access your Saving America Money team dashboard.</p>
        <form onSubmit={submit} className="space-y-3">
          <div><Label className="text-xs">New password</Label><Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="invite-password" placeholder="At least 8 characters" /></div>
          <div><Label className="text-xs">Confirm password</Label><Input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="invite-password-confirm" /></div>
          <div><Label className="text-xs">Your area ZIP code(s) <span className="text-sam-slate font-normal">— optional, new postcard runs here are assigned to you</span></Label><Input value={zips} onChange={(e) => setZips(e.target.value)} data-testid="invite-territory-zips" placeholder="e.g. 65708, 65804" /></div>
          <div><Label className="text-xs">Mobile for card alerts <span className="text-sam-slate font-normal">— optional, we text you when your card is close to mailing</span></Label><Input type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} data-testid="invite-alert-phone" placeholder="e.g. 417-555-0123" /></div>
          <Button type="submit" disabled={busy} className="w-full bg-sam-crimson hover:bg-sam-crimson/90" data-testid="invite-submit">
            {busy ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}Set password & continue
          </Button>
        </form>
      </div>
    </div>
  );
}
